import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'
import Toast from 'vue-toastification'

import App from './App.vue'
import router from './router'

// Стили
import './styles/main.scss'
import 'vue-toastification/dist/index.css'
import 'element-plus/dist/index.css'
import './styles/element-plus-overrides.css'

// Переводы
import uk from './locales/uk.json'

// CSRF cookie не требуется, так как используем токены для API

// Настройка i18n
const i18n = createI18n({
  legacy: false,
  locale: 'uk',
  fallbackLocale: 'uk',
  messages: {
    uk
  }
})

export const API_URL = import.meta.env.VITE_API_URL || ''

// Создание приложения
const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(Toast, {
  position: 'top-right',
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false
})

app.mount('#app')